const FieldError = ({ children }: { children: string }) => {
  return <p className="text-sm text-red-500">{children}</p>
}

export default FieldError
